require('./openYoungCardChoresFilter.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@utilities
const { FormattedText } = require('core/i18n').i18n;
//@commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKModal = require('components/commons/OKModal/OKModal');

const { choresStatus } = require('constants/openYoungCardChores');

class OpenYoungCardChoresFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilters } = props;
        this.state = {
            dateSelected: immFilters.getIn(['date', 'selected']),
            dateFrom: immFilters.getIn(['date', 'from']),
            dateTo: immFilters.getIn(['date', 'to']),
            statusSelected: immFilters.getIn(['status', 'status']),
            statusList: choresStatus()
        };

        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
    }

    handleChangeDateMax (dateTo) {
        this.setState({ dateTo });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({ dateFrom });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({ dateSelected });
    }

    handleOnSubmit() {
        const { dateSelected, dateTo, dateFrom, statusSelected } = this.state;
        this.props.onFilterSubmitClick({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            status: {
                status: statusSelected
            }
        });
        this.props.onCloseClick();
    }

    handleStatusChange(value) {
        this.setState({
            statusSelected: value.value
        });
    }

    buildStatusFilter() {
        return (
            <div className="openyoung-card-chores-filter__status">
                <div className="openyoung-card-chores-filter date-filter__title">
                    <FormattedText format="firstUppercase" value="openYoungChoresList-status" />
                </div>
                <OKSelect
                    name="card-chores-status-filter-dropdown"
                    onChange={this.handleStatusChange}
                    value={this.state.statusSelected}
                    options={this.state.statusList}
                    searchable={false}
                    clearable={false}
                    openUp={true}
                />
            </div>
        );
    }

    render() {
        const { onCloseClick, immFilters, isOpen } = this.props;
        const statusFilter = this.buildStatusFilter();
        const contentModal = (
            <React.Fragment>
                <DateFilter
                    immFilter={immFilters.get('date')}
                    onChangeMin={this.handleChangeDateMin}
                    onChangeMax={this.handleChangeDateMax}
                    onChangeSelected={this.handleChangeDateSelected}
                    showAnnual={false}
                />
                {statusFilter}
            </React.Fragment>
        );
        return (
            <OKModal
                content={contentModal}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleOnSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="cards-filterMovements"
                type="filter"
            />
        );
    }
}

OpenYoungCardChoresFilter.propTypes = {
    immFilters: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onFilterSubmitClick: PropTypes.func.isRequired,
};

module.exports = OpenYoungCardChoresFilter;
